export default __webpack_public_path__ + "static/media/social_network.76291741.svg";